// @flow

import { REMOVE_TERM_FILTER, ADD_TERM_FILTER, REMOVE_TERM_LABEL } from '../../constants';
import type { TermFilters } from '../../types';

export type TermFilterState = TermFilters;

type RemoveTermFilter = {
  type: typeof REMOVE_TERM_FILTER,
  payload: {
    label: string,
    bucket: string,
  },
};

type AddTermFilter = {
  type: typeof ADD_TERM_FILTER,
  payload: {
    label: string,
    bucket: string,
  },
};

type RemoveTermLabel = {
  type: typeof REMOVE_TERM_LABEL,
  payload: {
    label: string,
  },
};

const initialState: TermFilterState = {};

const filter = (
  state: TermFilterState = initialState,
  action: AddTermFilter | RemoveTermFilter | RemoveTermLabel,
): TermFilterState => {
  switch (action.type) {
    case REMOVE_TERM_LABEL: {
      const { [action.payload.label]: omit, ...rest } = state;
      return rest;
    }
    case REMOVE_TERM_FILTER: {
      const { bucket, label } = action.payload;

      if (!state[label]) {
        return state;
      }

      const filters = new Set(state[label]);
      filters.delete(bucket);

      return {
        ...state,
        [label]: Array.from(filters),
      };
    }
    case ADD_TERM_FILTER: {
      const { bucket, label } = action.payload;

      const filters = new Set(state[label] || []);
      filters.add(bucket);

      return {
        ...state,
        [label]: Array.from(filters),
      };
    }
    default:
      return state;
  }
};

export default filter;
